import React from 'react';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import Header from '../../components/Header';

const PrivacyPolicy = () => {
  useDocumentTitle('Privacy Policy');

  return (
    <div className="inner-wrapper">
      <Header />
      <div className="container">
        <h1 className="site-color-dark-red mb-4">Privacy Policy</h1>
        <div className="static-content">
          <p>This Privacy Policy (‘Policy’) is published in compliance with inter alia: Digital Personal Data Protection Act, 2023; and Section 43A of the Information Technology Act, 2000 (“IT Act”); Rule 4 of the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011 (“SPDI Rules”); and Rule 3(1) of the Information Technology (Intermediaries Guidelines) Rules, 2011.</p>

          <p>This Policy is entered into by and between <strong>Shree Mahatab Jankalyan Adhyatmik Satsang Samiti</strong> (the ‘Samiti’) and you. It governs your use of the application ‘Nirakar Satguru’ and the website <strong>https://www.nirakarsatguru.org</strong>.</p>

          <p>By using the App/Website, you agree to the terms and consent to data collection as outlined here.</p>

          <h2>Scope</h2>
          <p>This Policy applies only to your use of our App/Website. It does not cover external links or platforms. Our App is not intended for individuals under 18 without parental consent.</p>

          <h2>User Provided Information</h2>
          <p>We collect name, phone number, and OTP during registration. We may also collect details when you contact us or participate in donation transactions.</p>

          <h2>Automatically Collected Information</h2>
          <p>We collect device type, IP address, OS, and usage patterns. We use Razorpay for donations but do not store card information ourselves.</p>

          <h2>Use of Personal Information</h2>
          <ul>
            <li>To manage accounts and services</li>
            <li>To communicate updates and newsletters</li>
            <li>To improve user experience and conduct analytics</li>
            <li>To comply with legal or health-related requirements when applicable</li>
          </ul>

          <h2>Cookies</h2>
          <p>We use cookies for preferences and usage tracking. You may disable them in browser settings.</p>

          <h2>Alerts and Communication</h2>
          <p>We may notify you through email, SMS, or WhatsApp for updates or events.</p>

          <h2>Public Forums</h2>
          <p>Information shared in public areas like comments will be visible to others and done at your own risk.</p>

          <h2>Data Retention</h2>
          <p>We retain personal data only as long as required or legally mandated.</p>

          <h2>Log Information</h2>
          <p>Our servers may log browser details, date/time of visit, and IP address for technical and security purposes.</p>

          <h2>Information Security</h2>
          <p>We follow reasonable security practices but cannot guarantee absolute security over the internet.</p>

          <h2>Links to Other Sites</h2>
          <p>We are not responsible for privacy practices of third-party sites linked through our app.</p>

          <h2>Policy Updates</h2>
          <p>Policy may change from time to time. Continued use of the app implies acceptance of such changes.</p>

          <h2>Consent</h2>
          <p>By using the App or Website, you consent to our collection and use of data as described. You may withdraw consent anytime by emailing us at <strong>info@nirakarsatguru.org</strong>.</p>

          <h2>Children’s Information</h2>
          <p>The app is not meant for children under 18 unless used under guardian supervision.</p>

          <h2>Grievance Redressal</h2>
          <p>For any complaints, please contact:</p>
         
          <p>Shri Ravindra Nath Tiwari<br/>
          Secretary,<br/>
          Shree Mahatab Jankalyan Adhyatmik Satsang Samiti<br/>
            📧 <a href="mailto:support@nirakarsatguru.org">support@nirakarsatguru.org</a><br />
            Phone: +91-9651303202
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
